import * as tslib_1 from "tslib";
import * as checkout from '../actions/checkout';
var initialState = {
    error: null,
    creating: false,
    summaryOrder: null,
    deliverydates: null,
    backordercounts: {}
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case checkout.SUBMIT:
            return tslib_1.__assign({}, state, { error: null, creating: true });
        case checkout.SUBMIT_SUCCESS:
            return initialState;
        case checkout.SUBMIT_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, creating: false });
        case checkout.CLEAR_ERROR:
            return tslib_1.__assign({}, state, { error: null });
        case checkout.ORDER_SUMMARY:
            return tslib_1.__assign({}, state, { summaryOrder: action.payload });
        case checkout.GET_DELIVERY_DATES_SUCCESS:
            return tslib_1.__assign({}, state, { deliverydates: action.payload });
        case checkout.GET_DELIVERY_DATES_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case checkout.CLEAR_DELIVERY_DATES:
            return tslib_1.__assign({}, state, { deliverydates: null });
        case checkout.GET_BACKORDER_COUNTS_SUCCESS:
            return tslib_1.__assign({}, state, { backordercounts: action.payload });
        case checkout.GET_BACKORDER_COUNTS_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case checkout.CLEAR_BACKORDER_COUNTS:
            return tslib_1.__assign({}, state, { backordercounts: {} });
        default:
            return state;
    }
}
export var isCreating = function (state) { return state.creating; };
export var getError = function (state) { return state.error; };
export var getSummaryOrderNumber = function (state) { return state.summaryOrder; };
export var getDeliveryDates = function (state) { return state.deliverydates; };
export var getBackorderCounts = function (state) { return state.backordercounts; };
